import { BrowserRouter, Route, Routes } from 'react-router'

import AffirmationsApp, { AffirmationsChoice } from './AffirmationsApp'
import EmotionWheelApp from './EmotionWheelApp'
import IntlWrapper from './IntlWrapper'

function getRouterBasename() {
  const rawBasename = import.meta.env.VITE_ROUTER_BASENAME

  if (!rawBasename || rawBasename === '/') {
    return '/'
  }

  const withLeadingSlash = rawBasename.startsWith('/') ? rawBasename : `/${rawBasename}`

  return withLeadingSlash.replace(/\/+$/, '')
}

export default function App() {
  return (
    <IntlWrapper>
      <BrowserRouter basename={getRouterBasename()}>
        <Routes>
          <Route index element={<EmotionWheelApp />} />
          <Route path="affirmations">
            <Route index element={<AffirmationsApp />} />
            <Route path="choice/:type" element={<AffirmationsChoice />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </IntlWrapper>
  )
}
